import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type {
    ApiError,
    InteractionViewParams,
    InteractionViewResponse,
} from '@app/services/api.types';

type QueryOptions = Omit<
    UseQueryOptions<InteractionViewResponse, ApiError>,
    'queryKey' | 'queryFn'
>;

export const fetchInteraction = async ({
    id,
}: InteractionViewParams): Promise<InteractionViewResponse> => {
    if (id == null) throw new Error('Interaction ID is required');
    const url = apiEndpoints.interactions.getSingle(id);
    const response = await api.get(url);
    return response?.data;
};

const useInteraction = (params: InteractionViewParams, options?: QueryOptions) => {
    return useQuery<InteractionViewResponse, ApiError>({
        queryKey: ['interaction', 'single', params],
        queryFn: () => fetchInteraction(params),
        ...options,
        enabled: Boolean(params.id),
    });
};

export default useInteraction;
